import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import Header from "@components/Header/Header";
import KeywordFilter from "@features/mybt/components/KeywordFilter";
import PulseEntry from "@features/pulse/components/PulseEntry/PulseEntry";
import { getUrlPathFromAbsoluteUrl } from "@routes/Article/utils/helpers";
import { PodcastKeywordData } from "@routes/Podcasts/PodcastsKeywordPage/utils/types";
import { PODCASTS_KEYWORDS_DATA } from "@routes/Podcasts/utils/constants";

import PodcastsBanner from "./components/PodcastsBanner";
import PodcastsOverview from "./components/PodcastsOverview";

/**
 * Layout for Podcasts Keyword pages.
 * Figma: https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=1476-9947&t=m7103yrVxON0jRlB-4
 */
const PodcastsKeywordLayout = ({
  tag,
  overview,
  seoFooterData,
}: PodcastKeywordData): React.ReactElement => {
  const relativePath = getUrlPathFromAbsoluteUrl(tag.urlPath);
  const podcastKeyword = PODCASTS_KEYWORDS_DATA.find((data) => {
    return data.tag.urlPath === relativePath;
  });

  return (
    <div
      className="w-full"
      data-testid="podcasts-keyword-page-content-component"
    >
      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header />

      <PulseEntry />

      <Container rootClassName="py-8">
        <div>
          {tag ? (
            <KeywordFilter
              tag={tag}
              className="mb-6 inline-block w-max bg-gray-250 p-3"
              tagClassName="flex-none"
              buttonClassName="!ml-2"
            />
          ) : null}

          {podcastKeyword ? <PodcastsBanner details={podcastKeyword} /> : null}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3">
          <div className="col-span-2">
            <p className="mb-0 border-t border-gray-850 pt-3 font-poppins font-bold uppercase tracking-[0.02em] lg:text-lg">
              episodes
            </p>

            <>
              {podcastKeyword && overview?.length > 0 ? (
                <PodcastsOverview
                  cardProps={overview}
                  tagUrlPath={tag.urlPath}
                />
              ) : null}
            </>
          </div>

          <div className="col-span-1">
            <Ad
              adType="imu2"
              className="flex flex-col items-center justify-center lg:!sticky lg:top-[70px]"
            />
          </div>
        </div>
      </Container>

      <SeoFooter data={seoFooterData} />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default PodcastsKeywordLayout;
